import {
  Cog6ToothIcon,
  HomeIcon,
  ArchiveBoxArrowDownIcon,
  HomeModernIcon,
  ScaleIcon,
  TruckIcon,
  ArrowPathRoundedSquareIcon,
  WrenchIcon,
  NewspaperIcon,
  BeakerIcon,
} from "@heroicons/react/24/outline";
import { isReadOnlyUser } from "./utility";

export default function routes(pathname, user_type, user_id = null) {
  var title;
  var routes;

  const isCFIA = user_type === 4;
  // determine if the current user is read-only (utility handles the logic)
  const isReadOnly = isReadOnlyUser(user_type, user_id);

  // Helper function to create children arrays with conditional add/create items
  const createReceivingChildren = () => {
    const children = [{ name: "History", href: "/receiving", current: false }];
    if (!isReadOnly) {
      children.unshift({
        name: "Add new",
        href: "/receiving/new",
        current: false,
      });
    }
    return children;
  };

  const createWipChildren = () => {
    const children = [{ name: "History", href: "/wips", current: false }];
    if (!isReadOnly) {
      children.unshift({ name: "New WIP", href: "/wips/new", current: false });
    }
    return children;
  };

  routes = [
    {
      name: "Dashboard",
      href: "/dashboard",
      icon: HomeIcon,
      current: false,
      showInMenu: !isCFIA,
    },
    {
      name: "Receiving",
      icon: ArchiveBoxArrowDownIcon,
      current: false,
      showInMenu: !isCFIA,
      children: createReceivingChildren(),
    },
    {
      name: "WIP",
      icon: HomeModernIcon,
      current: false,
      showInMenu: !isCFIA,
      children: createWipChildren(),
    },
    {
      name: "Shipments",
      icon: TruckIcon,
      current: false,
      showInMenu: !isCFIA,
      children: [
        { name: "Shipments", href: "/shipments", current: false },
        { name: "Credit Returns", href: "/credit-returns", current: false },
      ],
    },
    {
      name: "Products",
      href: "/products",
      icon: WrenchIcon,
      current: false,
      showInMenu: !isCFIA,
    },
    {
      name: "Inventory",
      icon: ScaleIcon,
      current: false,
      showInMenu: !isCFIA,
      children: [
        { name: "Current Inventory", href: "/inventory", current: false },
        { name: "Cycle Counts", href: "/cycle-counts", current: false },
        {
          name: "Inventory History",
          href: "/inventory-history",
          current: false,
        },
        {
          name: "Low Inventory",
          href: "/low-in-stock",
          current: false,
        },
        {
          name: "Missing Inventory",
          href: "/missing-stock",
          current: false,
        },
      ],
    },
    {
      name: "Traceability",
      icon: ArrowPathRoundedSquareIcon,
      current: false,
      showInMenu: !isCFIA,
      children: [
        { name: "Barcode History", href: "/barcode-history", current: false },
        { name: "Traceability", href: "/traceability", current: false },
      ],
    },
    {
      name: "QA Reports",
      href: "/qa-reports",
      icon: NewspaperIcon,
      current: false,
      showInMenu: !isCFIA,
    },
    {
      name: "Lab Samples",
      href: "/lab-samples",
      icon: BeakerIcon,
      current: false,
      showInMenu: !isCFIA,
    },
    {
      name: "Setup",
      icon: Cog6ToothIcon,
      current: false,
      showInMenu: !isCFIA,
      open: false,
      children: [
        {
          name: "Allergens",
          href: "/allergens",
          current: false,
        },
        {
          name: "Box Types",
          href: "/box-types",
          current: false,
        },
        {
          name: "Carriers",
          href: "/carriers",
          current: false,
        },
        {
          name: "Categories",
          href: "/categories",
          current: false,
        },
        {
          name: "Classes",
          href: "/classes",
          current: false,
        },
        {
          name: "Currencies",
          href: "/currencies",
          current: false,
        },
        {
          name: "Customers",
          href: "/customers",
          current: false,
        },
        {
          name: "Customer Types",
          href: "/customer-types",
          current: false,
        },
        {
          name: "Graphics",
          href: "/graphics",
          current: false,
        },
        {
          name: "Laboratories",
          href: "/laboratories",
          current: false,
        },
        {
          name: "Product Colours",
          href: "/product-colours",
          current: false,
        },
        {
          name: "Product Odours",
          href: "/product-odours",
          current: false,
        },
        {
          name: "Product Tastes",
          href: "/product-tastes",
          current: false,
        },
        {
          name: "Reason Codes",
          href: "/reason-codes",
          current: false,
        },
        {
          name: "Rooms",
          href: "/rooms",
          current: false,
        },
        {
          name: "Spec sheet tests",
          href: "/spec-sheet-tests",
          current: false,
        },
        {
          name: "Stations",
          href: "/stations",
          current: false,
        },
        {
          name: "Suppliers",
          href: "/suppliers",
          current: false,
        },
        {
          name: "Tax rates",
          href: "/tax-rates",
          current: false,
        },
        { name: "Users", href: "/users", current: false },
        {
          name: "Warehouses",
          href: "/warehouses",
          current: false,
        },
      ],
    },
  ];

  // Remove the Setup section entirely for read-only users
  if (isReadOnly) {
    // i also want to filter for lab samples
    routes = routes.filter(
      (route) => route.name !== "Setup" && route.name !== "Lab Samples"
    );
  }

  routes.forEach((route) => {
    route.open = false;
    if (route.children) {
      route.children.forEach((child) => {
        child.current = false;
        if (child.href === pathname) {
          route.open = true;
          child.current = true;

          title = child.name;
        }
      });
    } else if (route.href === pathname) {
      route.current = true;

      title = route.name;
    }
  });

  var returnArray = {
    routes: routes.filter((route) => route.showInMenu),

    title: title,
  };

  return returnArray;
}
